var _path, _path2, _circle, _path3;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgIcLgActive = function SvgIcLgActive(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "ic-lg-active_svg__ic-lg-active",
    viewBox: "0 0 33 33",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M16.0026 33C19.1676 33 22.2615 32.0615 24.8931 30.3031C27.5247 28.5447 29.5758 26.0454 30.787 23.1214C31.9982 20.1973 32.3151 16.9797 31.6977 13.8755C31.0802 10.7713 29.5561 7.91992 27.3181 5.68192C25.0801 3.44392 22.2287 1.91983 19.1245 1.30236C16.0203 0.684903 12.8027 1.00181 9.87865 2.213C6.95456 3.4242 4.4553 5.47529 2.69692 8.10689C0.938534 10.7385 0 13.8324 0 16.9974C0 21.2416 1.68598 25.3119 4.68704 28.313C7.68811 31.314 11.7584 33 16.0026 33Z",
    fill: "#A50034"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M27.6962 17.3C27.5371 23.6231 22.3614 28.7 16 28.7C9.53827 28.7 4.3 23.4617 4.3 17C4.3 10.5383 9.53827 5.3 16 5.3V4C8.8203 4 3 9.8203 3 17C3 24.1797 8.8203 30 16 30C23.0794 30 28.8372 24.3411 28.9966 17.3H29V16H20V17.3H27.6962Z",
    fill: "white"
  })), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 11,
    cy: 12,
    r: 2,
    fill: "white"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M16.3 10H15V24H20V22.7H16.3V10Z",
    fill: "white"
  })));
};
export default SvgIcLgActive;